import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tree-layout',
  templateUrl: './tree-layout.component.html',
  styleUrls: ['./tree-layout.component.scss']
})
export class TreeLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
